import type { AuthRuntimeConfig } from '@/config/env';
import { env } from '@/config/env';
import { CognitoAuthService, configureCognito } from '@/features/auth/cognito';

import type { AuthService } from './AuthService';
import { createBrowserSessionStores } from './authSessionStorage';
import { MockAuthService } from './mockAuthService';

export function createAuthService(config: AuthRuntimeConfig): AuthService {
  if (config.authMode === 'cognito') {
    configureCognito(config.cognito);
    return new CognitoAuthService();
  }
  const stores = createBrowserSessionStores();
  return new MockAuthService(stores.persistent, stores.temporary);
}

export const authService = createAuthService(env);
